import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    'id': null, // optional
    'tieu_de': null, // required Tiêu đề tin tức
    'hien_thi': null, // required hien thi
    'description': null, // required Mô tả tin tức
    'content': null, // required Nội dung tin tức
    'ngon_ngu': null, // required Ngôn ngữ hiển thị
    "trang_thai": null, // required, min: 0, max: 2 0: duyệt, 1: chờ đã duyệt, 2: Từ chối
    "image_id": null, // required Id hình ảnh
    "thoi_diem_tao": null, // required Thời gian tạo bản ghi
    "nguoi_tao": null, // required
    "luot_xem": null, // optional Số lượt xem
    "ten_nguoi_tao": null,
    "ten_nguoi_cap_nhat": null,
    "nguon_bai_viet": [],
    "tags": [],
    "category": null, // optional Loại bài viết. News: Tin tức, SafePlace: Điểm đến
    "thanh_pho": null, // optional Thành phố của điểm đến
    "dia_chi": null, // optional Địa chỉ điểm đến
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg .gif",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
};

model.validForm = {
    'tieu_de': [ValidService.required],
    'description': [ValidService.required],
    'content': [ValidService.required],
    'image_id': [ValidService.required],
    'hien_thi': [ValidService.required],
    'ngon_ngu': [ValidService.required],
    'nguon_bai_viet': [ValidService.required],
    'tags': [ValidService.required],
    "thanh_pho": [ValidService.required], // optional Thành phố của điểm đến
    "dia_chi": [ValidService.required], // optional Địa chỉ điểm đến
}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            tieu_de: "",
            ngon_ngu: "",
            nguoi_tao: "",
            thoi_diem_tao: "",
            hien_thi:""
        },
        valid: {
            tieu_de: [],
            ngon_ngu: [],
            nguoi_tao: [],
            thoi_diem_tao: [],
            hien_thi:[]
        },
        operator: {
            tieu_de: "$vn_text=", //:regex:, $vn_text=Viêt nam
            ngon_ngu: "",
            nguoi_tao: "",
            thoi_diem_tao: ":in_that_day:",
            hien_thi:""
        }
    }
};

export default model;